import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { FeedbackService } from '../service/feedback.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ListComponent implements OnInit, OnDestroy{

  @Input() currentResponseId= '';
  feedbacks: any;
  isListloading = false;
  isfeedbackAdded = false;
  feedbackListSubscription?: Subscription;
  feedbackEmitterSubscription?: Subscription;
  constructor(private readonly feedbackService: FeedbackService) {
  }
   

  ngOnInit(): void {    
    this.feedbackEmitterSubscription=this.feedbackService.feedbackEmitter.subscribe({ 
      next: (data) =>     
      {
        const date = new Date();
        var feedback = {"content": data.comment,"author":this.feedbackService.currentUser,"createdLocal":date};
        if (data && data.responseId == this.currentResponseId) {
          this.feedbacks.unshift(feedback);
         // this.getFeedbacks();
        }
      }       
    });
    this.getFeedbacks();    
  }

  getFeedbacks() {
    this.isListloading = true;
    this.feedbackListSubscription =this.feedbackService.getFeedbacks(Number(this.currentResponseId)).subscribe({
      next: (data) => this.feedbacks = data,
      complete: () => { this.isListloading = false; }
    });  
  }
  ngOnDestroy(): void {
    this.feedbackListSubscription?.unsubscribe();
    this.feedbackEmitterSubscription?.unsubscribe();
  }
}
